import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    CircularProgress,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    Chip,
    IconButton,
    Menu,
    MenuItem,
    Snackbar,
    Alert as MuiAlert,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate, useLocation } from "react-router-dom";
import { getStoreCounters } from "../../Apis/storecounterApi";

const StoreCounterList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { storeId } = location.state || {}; // get storeId from GetAdminStores
    console.log("Store ID:", storeId);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [storeCounters, setStoreCounters] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCounter, setSelectedCounter] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    useEffect(() => {
        fetchCounters();
    }, [storeId]);

    const fetchCounters = async () => {
        try {
            setLoading(true);
            setError("");
            const response = await getStoreCounters(storeId);
            setStoreCounters(Array.isArray(response.data) ? response.data : [response.data]);
        } catch (err) {
            setError("Failed to load store counters.");
        } finally {
            setLoading(false);
        }
    };

    const handleMenuOpen = (event, counter) => {
        setAnchorEl(event.currentTarget);
        setSelectedCounter(counter);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedCounter(null);
    };

    const getStatusLabel = (status) => (status ? "Active" : "Inactive");
    const normalizeStatus = (status) => status;

    return (
        <Box sx={{ padding: 3, width: "90%" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                <Typography variant="h4" fontWeight="bold">Store Counters</Typography>
                <Button variant="contained" onClick={() => navigate("/storecounter/add", { state: { storeId } })}>
                    + Add Store Counter
                </Button>
            </Box>

            {loading && <Box display="flex" justifyContent="center" alignItems="center" height={200}><CircularProgress /></Box>}
            {error && <MuiAlert severity="error">{error}</MuiAlert>}

            {!loading && storeCounters.length > 0 && (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Name</TableCell>
                                {/* <TableCell>Status</TableCell> */}
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {storeCounters.map((counter, index) => (
                                <TableRow key={counter.id}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{counter.name}</TableCell>
                                    {/* <TableCell>
                                        <Chip label={getStatusLabel(counter.status)} color={normalizeStatus(counter.status) ? "success" : "error"} size="small" />
                                    </TableCell> */}
                                    <TableCell>
                                        <IconButton onClick={(e) => handleMenuOpen(e, counter)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleMenuClose}
                                        >
                                            <MenuItem onClick={() => { navigate("/storecounter/edit", { state: { counterData: selectedCounter } }); handleMenuClose(); }}>
                                                Edit
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {!loading && storeCounters.length === 0 && <Typography sx={{ textAlign: "center", mt: 3 }}>No store counters found.</Typography>}

            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <MuiAlert severity={snackbar.severity}>{snackbar.message}</MuiAlert>
            </Snackbar>
        </Box>
    );
};

export default StoreCounterList;
